import launchpack_default_admin_menu from '../../raw_data/menu/launchpack/default_admin_menu.json'
import launchpack_default_partner_menu from '../../raw_data/menu/launchpack/default_partner_menu.json'

import default_admin_menu from '../../raw_data/menu/default_admin_menu.json'
import default_partner_menu from '../../raw_data/menu/default_partner_menu.json'
import default_supervisor_menu from '../../raw_data/menu/default_supervisor_menu.json'

import shipagency_default_admin_menu from '../../raw_data/menu/shipagency/default_admin_menu.json'

import booking_default_admin_menu from '../../raw_data/menu/booking/default_admin_menu.json'
import booking_default_partner_menu from '../../raw_data/menu/booking/default_partner_menu.json'

import call_default_admin_menu from '../../raw_data/menu/call/default_admin_menu.json'
import call_default_partner_menu from '../../raw_data/menu/call/default_partner_menu.json'

import space_default_admin_menu from '../../raw_data/menu/space/default_admin_menu.json'
import space_default_partner_menu from '../../raw_data/menu/space/default_partner_menu.json'

import commerce_default_admin_menu from '../../raw_data/menu/commerce/default_admin_menu.json'
import commerce_default_partner_menu from '../../raw_data/menu/commerce/default_partner_menu.json'

import delivery_default_admin_menu from '../../raw_data/menu/delivery/default_admin_menu.json'
import delivery_default_partner_menu from '../../raw_data/menu/delivery/default_partner_menu.json'

import estimate_default_admin_menu from '../../raw_data/menu/estimate/default_admin_menu.json'
import estimate_default_partner_menu from '../../raw_data/menu/estimate/default_partner_menu.json'

import group_default_admin_menu from '../../raw_data/menu/group/default_admin_menu.json'
import group_default_partner_menu from '../../raw_data/menu/group/default_partner_menu.json'
import group_default_superpartner_menu from '../../raw_data/menu/group/default_superpartner_menu.json'

import mart_default_admin_menu from '../../raw_data/menu/mart/default_admin_menu.json'
import mart_default_partner_menu from '../../raw_data/menu/mart/default_partner_menu.json'
import mart_default_supervisor_menu from '../../raw_data/menu/mart/default_supervisor_menu.json'

import meet_default_admin_menu from '../../raw_data/menu/meet/default_admin_menu.json'
import meet_default_partner_menu from '../../raw_data/menu/meet/default_partner_menu.json'

import outlink_default_admin_menu from '../../raw_data/menu/outlink/default_admin_menu.json'
import outlink_default_partner_menu from '../../raw_data/menu/outlink/default_partner_menu.json'

import reservation_default_admin_menu from '../../raw_data/menu/reservation/default_admin_menu.json'
import reservation_default_partner_menu from '../../raw_data/menu/reservation/default_partner_menu.json'

import counsel_default_admin_menu from '../../raw_data/menu/counsel/default_admin_menu.json'
import counsel_default_partner_menu from '../../raw_data/menu/counsel/default_partner_menu.json'

import lp_admin_menu from '../../raw_data/menu/lp_admin_menu'
import admin_marketing_menu from '../../raw_data/menu/admin_marketing_menu'

export default {
  data() {
    return {
      menu_set: {
        launchpack_default_admin_menu: launchpack_default_admin_menu,
        launchpack_default_partner_menu: launchpack_default_partner_menu,
        default_admin_menu: default_admin_menu,
        default_partner_menu: default_partner_menu,
        default_supervisor_menu: default_supervisor_menu,
        shipagency_default_admin_menu: shipagency_default_admin_menu,
        booking_default_admin_menu: booking_default_admin_menu,
        booking_default_partner_menu: booking_default_partner_menu,
        call_default_admin_menu: call_default_admin_menu,
        call_default_partner_menu: call_default_partner_menu,
        space_default_admin_menu: space_default_admin_menu,
        space_default_partner_menu: space_default_partner_menu,
        commerce_default_admin_menu: commerce_default_admin_menu,
        commerce_default_partner_menu: commerce_default_partner_menu,
        delivery_default_admin_menu: delivery_default_admin_menu,
        delivery_default_partner_menu: delivery_default_partner_menu,
        estimate_default_admin_menu: estimate_default_admin_menu,
        estimate_default_partner_menu: estimate_default_partner_menu,
        group_default_admin_menu: group_default_admin_menu,
        group_default_partner_menu: group_default_partner_menu,
        group_default_superpartner_menu: group_default_superpartner_menu,
        mart_default_admin_menu: mart_default_admin_menu,
        mart_default_partner_menu: mart_default_partner_menu,
        mart_default_supervisor_menu: mart_default_supervisor_menu,
        meet_default_admin_menu: meet_default_admin_menu,
        meet_default_partner_menu: meet_default_partner_menu,
        outlink_default_admin_menu: outlink_default_admin_menu,
        outlink_default_partner_menu: outlink_default_partner_menu,
        reservation_default_admin_menu: reservation_default_admin_menu,
        reservation_default_partner_menu: reservation_default_partner_menu,
        counsel_default_admin_menu: counsel_default_admin_menu,
        counsel_default_partner_menu: counsel_default_partner_menu,
        lp_admin_menu: lp_admin_menu,
        admin_marketing_menu: admin_marketing_menu
      },
      packages: [],
      menus: [],
      menuPack: [],
      menu_setting: [],
      origin_menus: [],
      computedMenu: [],
      dashboard: undefined,
      //allPackages: ['call', 'delivery', 'reservation', 'booking', 'meet', 'counsel', 'outlink', 'estimate', 'commerce', 'mart'],
      inquiryPackages: ['meet', 'counsel', 'outlink', 'estimate', 'commerce', 'mart'],
    }
  },
  mounted() {
    this.$axios.get('public/service/setting').then(res => {
      this.packages = res.data.packages;
      this.$store.commit('setGuide', res.data.new_package);
      this.getMenus();
    })
    this.$root.$on('menus', res => {
      this.$axios.get('public/service/setting').then(res => {
        this.packages = res.data.packages;
        this.getMenus();
      })
    });
  },
  methods: {
    addSelected(item) {
      item.selected = false;
      if (item.child && item.child.length > 0)
        item.child.forEach(child => {
          this.addSelected(child);
        });
    },
    getPackageTitle(pack) {
      return {
        reservation: '시간단위 서비스 예약',
        booking: '기간단위 서비스 예약',
        call: '전화 주문',
        delivery: '상품 택배 배송',
        mart: '예약 배달',
        estimate: '입찰 견적',
        outlink: '아웃링크',
        meet: '모임신청',
        counsel: '상담신청',
        commerce: '다운로드 상품',
        group: '팀 그룹',
        space: '공간 전화 주문',
        shipagency: '배송대행 신청'
      }[pack];
    },
    async getMenus() {
      /*let url = ''
      if (this.$store.getters.mode === 'admin')
        url = 'admin/menu';
      else if (this.$store.getters.mode === 'superpartner')
        url = 'superpartner/' + this.$store.getters.superpartner.user_id + '/menu';
      else if (this.$store.getters.mode === 'supervisor') {
        url = 'supervisor/' + this.$store.getters.supervisor.id + '/menu';
      } else
        url = 'partner/' + this.$store.getters.partner.partner_id + '/menu';

      if (this.$route.path.indexOf('/group_admin') > -1) {
        url += '/group';
      }
      // 메뉴 가져오기 (추가게시판용)
      try {
        let res = await this.$axios.get(url);
        if (res.status === 200) {
          this.setMenu(res.data);
          this.menu_setting = res.data.menu_setting;
        }
      } catch (err) {
        this.adminOnError(err.response.status);
      }*/
      this.setMenu();
      if (this.$store.getters.mode === 'admin') {
        try {
          let res = await this.$axios.get('admin/service/adminmenu');
          if (res.status === 200) {
            this.setMenu(res.data);
            this.menu_setting = res.data;
          }
        } catch (err) {
          this.adminOnError(err.response.status);
        }
      } else if (this.$store.getters.mode === 'partner') {
        try {
          let res = await this.$axios.get(`partner/${this.$store.getters.partner.partner_id}/service/partnermenu`);
          if (res.status === 200) {
            this.setMenu(res.data);
            this.menu_setting = res.data;
          }
        } catch (err) {
          this.adminOnError(err.response.status);
        }
      }

      // 앱마켓 띄우기
      if(this.$store.getters.openAppMarket) {
        setTimeout(()=>
        {
          this.$root.$emit('appMarket');
          //this.$store.commit('setOpenAppMarket', false);
        },1000)
      }
    },
    setEnable(menuData) {
      for (let i=0; i<menuData.length; i++) {
        let item = this.findMenu(menuData[i].menu_id);
        if(item) menuData[i].enable = item.enable;
        if(menuData[i].child) {
          this.setEnable(menuData[i].child)
        }
      }
    },
    getMenuFromId(item, menu_id) {
      if(item.menu_id === menu_id) {
        return item;
      } else {
        if(item.child) {
          for(let child of item.child) {
            let result = this.getMenuFromId(child, menu_id);
            if(result) {
              return result;
            }
          }
        }
      }
      return undefined;
    },
    findMenu(menu_id) {
      let type = this.$store.getters.mode;
      return this.getMenuFromId({menu_id:0, child: this.menu_setting[type]}, menu_id);
    },
    async getMenu(type) {
      let packs = this.packages;
      let menus = this.cloneItem(this.menu_set[`default_${type}_menu`]);
      for(let pack_name of packs) {
        let menu_item = this.menu_set[`${pack_name}_default_${type}_menu`];
        if(menu_item) {
          menu_item.forEach(i => { i.key = pack_name });
        }
        menus = menus.concat(menu_item);
      }
      return menus;
    },
    async setMenu(data) {
      let packs = this.cloneItem(this.packages);
      let mode = this.$store.getters.mode;    // admin, partner, superpartner, supervisor
      let menus = [];
      // 슈퍼어드민일 때, launchpack_default_admin_menu로 설정
      if (this.isLaunchpack) {
        menus = this.cloneItem(this.menu_set[`launchpack_default_${mode}_menu`]);
      }
      // 공간파트너일 때, space_default_partner_menu 설정
      else if(this.$route.path.indexOf('space_partner')>-1) {
        menus = menus.concat(this.menu_set['space_default_partner_menu']);
      }
      // 관리자/파트너관리자일 때, default_admin_menu 또는 defalut_partner_menu
      else {
        menus = this.cloneItem([...this.menu_set[`default_${mode}_menu`]]);
        // pack 종류에 해당하는 default menu 추가
        for(let pack_name of packs) {
          let menu_item = this.menu_set[`${pack_name}_default_${mode}_menu`];
          menu_item.forEach(i => { i.key = pack_name });
          menus = menus.concat(menu_item);
        }
      }

      if(data && data.board_menu && data.board_menu.length>0) {
        // 추가 게시판 메뉴 추가
        let board = find(menus, 'menu_id', 'board');
        board.child = board.child.concat(data.board_menu);
      }

      await menus.forEach(item => {
        this.addSelected(item);
      });

      if(this.$store.getters.mode === 'admin' && this.menu_setting && this.menu_setting[this.$store.getters.mode]) {
        this.setEnable(menus);
      } else {
        this.setEnable(menus);
      }

      menus = this.cloneItem(menus);
      this.menus = await menus.filter(m => !m.key);
      this.menuPack = [];

      if (this.$route.path.indexOf('space_partner')===-1 &&
        menus.findIndex(item => item.key !== undefined) > -1) {
        await packs.forEach(pack => {
          let hasPackages = this.packages.indexOf(pack)>-1;
          let inquiryPackages = this.inquiryPackages.indexOf(pack)>-1;
          this.menuPack.push({
            title: this.getPackageTitle(pack),
            pack: pack,
            market: !hasPackages && !inquiryPackages,
            inquiry: !hasPackages && inquiryPackages,
            expand: false,
            menu: menus.filter(m => m.key === pack)
          });
        });
      }
      this.$emit('done');

      let res = [{ menu: this.menus }];
      if(this.menuPack.length>0) {
        res[0].title = '서비스 설정';
        res = res.concat(this.menuPack);
      }
      if(this.isLaunchpack) {
        res[0].title = '서비스 설정';
      }

      if(this.$store.getters.mode === 'admin' && !this.isLaunchpack) {

        await this.menu_set.lp_admin_menu.forEach(item => {
          this.addSelected(item);
        });
        // service_version 2에서 앱마켓, 플랜 등 노출
        if(this.checkServiceVersion(2)) {
          if(this.$store.getters.masterServiceInfo) {
            if( this.$store.getters.masterServiceInfo.service_type === 4) {
              this.menu_set.lp_admin_menu = this.menu_set.lp_admin_menu.filter( i => i.menu_id !== 'schedule');
            } else {
              this.menu_set.lp_admin_menu =
                this.menu_set.lp_admin_menu.filter( i => ['schedule', 'app_market'].indexOf(i.menu_id) === -1);
            }
          }
        } else {
          this.menu_set.lp_admin_menu = this.menu_set.lp_admin_menu.filter( i => i.menu_id === 'schedule');
        }

        // 마케팅 관리 추가
        await this.menu_set.admin_marketing_menu.forEach(item => {
          this.addSelected(item);
        });
        this.setEnable(this.menu_set.admin_marketing_menu);
        res.splice(res.findIndex(i=>{return i.title === '서비스 설정' })+1,0, {
          title: '마케팅 관리',
          menu: this.menu_set.admin_marketing_menu
        });
      }

      this.computedMenu = this.cloneItem(res);

      if(this.computedMenu) {
        for(let menu of this.computedMenu) {
          if(menu.menu) {
            let dashboard = menu.menu.find(i => i.menu_id === 'dashboard');
            if(dashboard) {
              this.dashboard = dashboard;
              break;
            }
          }
        }
        this.computedMenu.forEach(item => {
          this.openSelectedMenu(item.menu);
        });
        this.moveSelectedMenu();
      }
      this.$store.commit('setMenus', this.computedMenu.reduce((a,c) => a.concat(c.menu), []));
    },
    removeMenuList(list) {
      for(let i=0; i<list.length; i++) {
        let menu = list[i].menu;
        //this.removeMenu(menu, '회원 정보 폼 관리')
      }
    },
    /*removeMenu(menu, menu_name) {
      for(let j=0; j<menu.length; j++) {
        if(menu[j].name===menu_name) {
          menu = menu.splice(j, 1);
          continue
        }
        if(menu[j].child && menu[j].child.length>0) {
          this.removeMenu(menu[j].child, menu_name);
        }
      }
    },*/
    // 페이지 로드시 메뉴 열기 (페이지 path와 메뉴의 path 같은 경우 selected=true)
    openSelectedMenu(menus) {
      let route_path = this.$route.path.replace(`/office/${this.$store.getters.mode}/`, '');

      menus.forEach(menu => {
        if(menu.path === route_path) {
          menu.selected = true;
        }
        if (menu.child) {
          menu.child.forEach(child => {
            if (child.path === route_path) {
              menu.selected = true;
            }
            if (child.child) {
              child.child.forEach(grandchild => {
                if (grandchild.path === route_path) {
                  child.selected = true;
                  menu.selected = true;
                }
              });
            }
          });
        }
      });
    },

    adminOnError(status) {
      if (status === 401) {
        this.adminOnError401();
      } else if (status === 404) {
        this.adminOnError404();
      } else {
        this.adminOnErrorUncaught(status);
      }
    },
    adminOnError401() {
      this.toast('로그인 정보가 일치하지 않습니다. 다시 로그인 해 주세요.');
      setTimeout(() => {
        this.$store.commit('logout');
        this.$router.replace(this.getPath('login'));
      }, 1000);
    },

    adminOnError404() {
      this.toast('관리자에게 문의 주세요.');
    },

    adminOnErrorUncaught(status) {
      //this.toast('관리자에게 문의 주세요.');
    },
    // 선택한 메뉴로 스크롤 이동
    moveSelectedMenu() {
      this.$nextTick(()=>{
        let el = document.getElementsByClassName('selected-text-color')[0];
        if(el) {
          if(el.innerText!=='대시보드') {
            let y = el.getBoundingClientRect().y + document.getElementById('hideScroll').scrollTop - 300;
            document.getElementById('hideScroll').scrollTo(0, y);
          }
        }
      })
    }
  }
}
